export enum SessionStorageKeys {
  INVOICE_FILTER_REJECTED = 'invoice_filter_rejected',
  INVOICE_FILTER_DISPATCHED = 'invoice_filter_dispatched',
  INVOICE_FILTER_VOUCHERVALIDATED = 'invoice_filter_invoiceVoucherValidated',
  INVOICE_FILTER_SEARCH = 'invoice_filter_search',
  INVOICE_FILTER_WAITING = 'invoice_filter_waiting',
  INVOICE_FILTER_LATE = 'invoice_filter_late',
  IMPORTS_LOG = 'imports_log',
  IMPORTS_LOG_DETAIL = 'imports_log_detail',
  INVOICE_FILTER_CONTROL = 'invoice_filter_control',
  INVOICE_WRONG_STATE = 'invoice_wrong_state',
  ANALYSIS_MISSING_INVOICE_NUMBERS = 'analysis_missing_invoice_numbers',
  ADMINISTRATION_GROUPS = 'administration_groups',
}
